import { render, staticRenderFns } from "./Preorders.vue?vue&type=template&id=340804d8"
import script from "./Preorders.vue?vue&type=script&lang=js"
export * from "./Preorders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports